/**
 * 报关贴纸管理- 侵权已确认详情
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import ImageHover from "../../Components/ImageHover";
import {Spin, Row, Col, Badge,Input} from 'antd';
import Lang from "@components/Lang/Lang";
import {isEmpty} from '@utils/utils';
import dayjs from "dayjs";
import "./Detail.less";
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";

const config = require("@config/config");
class InfringementConfirmDetails extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            item:{
                code:'PO单号'
            },
            list: [
            ],
            certDict: [
                { label: Lang({id:'YouZhengShu',default:'有证书'}), value: 1 },
                { label: Lang({id:'WuZhengShu',default:'无证书'}), value: 0 },
                // { label: 'Orange', value: 'Orange', disabled: true },
            ],
            model:{}
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        const postData = {
            id:sId,
            isSkuDetail:0,//是否需要sku详细信息		海关编码传1 其余传0
        }
        CustomsDeclarationStickerAction.getGoodsDetail(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        const {success,valid,models,model} = res;
        if(success&&valid){
            this.setState({
                list:models||[],
                model:model||{},
            })
            if(models.length>50){
                setTimeout(()=>this.loading(false),400)
            }else this.loading(false);
        }else this.loading(false);
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }
    /**
     * 渲染列表
     * @list 数据源
     * @type 编辑类型 edit 可编辑 view 查看状态，不可编辑
     * @certDict 证书类型
     * **/
    renderList(list=[],type='',certDict){
        let children = [];
        list.forEach((item,inx)=>{
            item.disabled = type=='view'?true:false;
            const list = item.tortRemarkList || [];
            children.push(<div className={'itemLi'} key={inx}>
                <Row gutter={24}>
                    <Col span={14}>
                        <div className={'pro'}>
                            {item.skuFileUrls&&item.skuFileUrls.length>0&&<ImageHover src={item.skuFileUrls[0]} />}
                        </div>
                        <div className={'info'}>
                            <p className={'skuMo'}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{item.skuNo}</span></p>
                            <p><a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`} target={'_blank'}>{item.skuName}</a></p>
                        </div>
                    </Col>
                    <Col span={6} offset={4}>
                        <div className={'statusName'}>
                            {item.isTort==0&&Lang({id: 'ZhengChang', default: '正常'})}
                            {item.isTort==1&&Lang({id: 'QinQuan', default: '侵权'})}
                            {list.map((txt,txtInx)=>{
                                return (<p><Badge key={txtInx} color={'orange'} text={txt} /></p>)
                            })}
                        </div>
                    </Col>
                </Row>
            </div>)
         });
        return children;
    }

    componentDidMount() {
        const { search } = this.props.location;
        // console.log('待确认',search)
        // console.log('待确认',this.props)
        const sId = this.getCerId(search);
        this.getDetail(sId);
    }
    componentWillUnmount(){
    }
    render(){
        const { loading,model,list,certDict,iId } = this.state;
        const currPageName = Lang({id: "QinQuanQueRen",default: "侵权确认"});
        const type = 'edit';

        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:currPageName,link:'/customsDeclarationSticker/infringementConfirmation'},{name:model&&model.poCode?model.poCode:''}]}></CommonBreadcrumb>
            <div className="infringementConfirmDetailsStyle">
                <div className={'handler'}>
                    <p className={'name'}>{Lang({id: "ChuLiRen",default: "处理人"})}<span>{model.handleName}</span></p>
                    <p className={'time'}>{model.handleTime?dayjs(model.handleTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</p>
                </div>
                <div className={'content'}>
                    <Row gutter={24} className={'listTitle'}>
                        <Col span={18}>
                            {Lang({id: "ShangPinXinXi",default: "商品信息"})}
                        </Col>
                        <Col span={6}>
                            {Lang({id: "QueRenJieGuo",default: "确认结果"})}
                        </Col>
                    </Row>
                    <div className={'itemList'}>
                        {this.renderList(list,type,certDict)}
                    </div>
                </div>
            </div>
        </Spin>)
    }
}
export default InfringementConfirmDetails;